import pluralize from 'pluralize';
import React from 'react';
import { useApi, useWorkspace } from '~/contexts';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import TaskDetails from './TaskDetails';

export default function BulkDelete({ projectId, useDependencies, ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  return (
    <BulkActionModal
      title="Bulk Delete"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projects(projectId)
          .tasks()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={TaskDetails}>
      {`Are you sure you want to delete ${ids.length} ${pluralize('task', ids.length)}?${useDependencies ? ' Any task dependencies will also be removed.' : ''} This action cannot be undone.`}
    </BulkActionModal>
  );
}
